import { accountMetaUpdate, customerTab } from "../locales/en";
import privateAxios from "../utils/axiosPrivate";
import { getUserUpdateMetaURL } from "../utils/constants/apiEndPoints";
import { showToastType } from "../utils/constants/appConstants";
import { showToast } from "../utils/utils";

const useUserMetaUpdater = ({
  id,
  setAccountMeta,
  successFallbackMessage,
  errorFallbackMessage
}) => {
  const updateUserMeta = async ({
    name,
    value,
    onSuccess,
    showSuccessMessage = true
  }) => {
    try {
      const dataToSend = {
        fieldName: name,
        value
      };

      const response = await privateAxios.patch(
        getUserUpdateMetaURL(id),
        dataToSend
      );

      if (response.status === 200) {
        setAccountMeta((prev) => ({ ...prev, [name]: value }));

        if (onSuccess) {
          onSuccess(response);
        }

        if (showSuccessMessage) {
          let successMsg =
            customerTab?.details.errMsg.item3 ||
            response?.data?.message ||
            successFallbackMessage;

          const fieldMap = {
            industryClassification: accountMetaUpdate?.item1,
            pricingIndustryId: accountMetaUpdate?.item2,
            primaryCountry: accountMetaUpdate?.item3,
            organisationType: accountMetaUpdate?.item4
          };

          if (fieldMap[name]) {
            successMsg = `${fieldMap[name]} ${accountMetaUpdate?.successMsg}`;
          }
          showToast(successMsg, showToastType.success);
        }
      } else {
        const errMsg = response?.data?.message || errorFallbackMessage;
        showToast(errMsg, showToastType.error);
      }

      return response;
    } catch (error) {
      showToast(error?.response?.data?.message, showToastType.error);
    }
  };

  return { updateUserMeta };
};

export default useUserMetaUpdater;
